// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima+Nova);"]);
// Module
exports.push([module.id, "html {\n    width: 100vw;\n    height: 100vh;\n    font-family: proxima-nova, sans-serif;\n}\n\nbody {\n    padding: 0;\n    color: rgb(102, 102, 102);\n}\n\ninput {\n    outline: none;\n}\n\n* {\n    box-sizing: border-box;\n}", ""]);
// Exports
module.exports = exports;
